import React from 'react';

export const ChevronIcon = () => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.50515 1.90633C6.89568 1.5158 6.89568 0.882636 6.50515 0.492112C6.11463 0.101588 5.48146 0.101588 5.09094 0.492112L0.29094 5.29211C-0.0995841 5.68264 -0.0995841 6.3158 0.29094 6.70633L5.09094 11.5063C5.48146 11.8969 6.11463 11.8969 6.50515 11.5063C6.89568 11.1158 6.89568 10.4826 6.50515 10.0921L2.41226 5.99922L6.50515 1.90633ZM13.7057 1.90633C14.0962 1.5158 14.0962 0.882636 13.7057 0.492112C13.3152 0.101588 12.682 0.101588 12.2915 0.492112L7.49146 5.29211C7.10094 5.68264 7.10094 6.3158 7.49146 6.70633L12.2915 11.5063C12.682 11.8969 13.3152 11.8969 13.7057 11.5063C14.0962 11.1158 14.0962 10.4826 13.7057 10.0921L9.61278 5.99922L13.7057 1.90633Z"
      fill="#5A5A5A"
    />
  </svg>
);
